import CommonApp from '../../app.js';

CommonApp.module.filter('origImageFilter', function() {
    return function(value) {
        if (value && value.indexOf('gigya.com') > -1) {
            value = value.replace('thumbnail', 'orig');
        }
        return value;
    };
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/filters/orig-image/orig-image.js
// module id = 275
// module chunks = 0